import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list ✨ Recipes & releases headed your way.");
      setEmail("");
    } catch (err) {
      toast.error(
        err?.response?.data?.detail?.[0]?.msg ||
          "Couldn't subscribe. Please try a valid email.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="relative py-20 lg:py-24"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl overflow-hidden bg-mo-terracotta text-mo-cream p-10 sm:p-14 lg:p-20 kraft-grain">
          <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-[#D99026]/40 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-[#8F2B17]/40 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7">
              <div className="text-xs uppercase tracking-[0.3em] text-[#F9F6F0]/80 mb-4">
                — The Kitchen Letter
              </div>
              <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05]">
                Slow recipes, quiet releases, <span className="italic">no spam.</span>
              </h2>
              <p className="mt-5 text-[#F9F6F0]/85 max-w-lg">
                One letter a month. Seasonal recipes from our kitchen, first
                dibs on new harvests, and the occasional farmer story.
              </p>
            </div>

            <form
              onSubmit={submit}
              data-testid="newsletter-form"
              className="lg:col-span-5 flex flex-col gap-3"
            >
              <label className="relative">
                <Mail
                  size={18}
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-[#F9F6F0]/70"
                />
                <input
                  type="email"
                  required
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="newsletter-email-input"
                  className="w-full pl-12 pr-4 py-4 rounded-full bg-[#F9F6F0]/15 border border-[#F9F6F0]/40 text-mo-cream placeholder-[#F9F6F0]/60 focus:outline-none focus:ring-2 focus:ring-[#F9F6F0]/70 backdrop-blur-sm"
                />
              </label>
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-mo-cream text-mo-terracotta font-medium hover:bg-[#F9F6F0]/90 transition-all duration-300 disabled:opacity-60"
              >
                {loading ? <Loader2 className="animate-spin" size={16} /> : null}
                Sign me up
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
